export default function formatTweet(text, entities) {
  let result = text

  const urls = (entities?.urls || []).map(url => ({
    ...url,
    type: "url"
  }))
  const hashtags = (entities?.hashtags || []).map(tag => ({
    ...tag,
    type: "hashtag"
  }))
  const mentions = (entities?.mentions || []).map(username => ({
    ...username,
    type: "mention"
  }))

  const replacements = [...urls, ...hashtags, ...mentions]

  replacements.forEach(entity => {
    if (entity.type == "url") {
      result = result.replace(
        entity.url,
        `<span style="color: #1B95E0"> ${entity.display_url}</span>`
      )
    } else if (entity.type == "hashtag") {
      result = result.replace(
        `#${entity.tag}`,
        `<span style="color: #1B95E0">#${entity.tag}</span>`
      )
    } else if (entity.type == "mention") {
      result = result.replace(
        `@${entity.username}`,
        `<span style="color: #1B95E0">@${entity.username}</span>`
      )
    }
  })

  return result
}
